import { toast } from "react-toastify";
import { TERMINAL_ERROR_CODES } from "@monorepo/constants";
import i18n from "@monorepo/translations";
import { IResponseError } from "@monorepo/types";
import { SerializedError } from "@reduxjs/toolkit";

/** Utility to make certain keys of a type required */
type TRequiredKeys<T, K extends keyof T> = Exclude<T, K> & Required<Pick<T, K>>;

export const errorTitle = (error: Array<IResponseError> | SerializedError | undefined) => {
  if (Array.isArray(error) && error[0].title) {
    return error[0].title;
  }
  return undefined;
};

export const isResponseErrorArray = (response: any): response is Array<IResponseError> => {
  return Array.isArray(response);
};

export const showErrorArrayTitles = (error: any): void => {
  if (isResponseErrorArray(error)) {
    error.forEach((x) => {
      toast.error(x.title);
    });
  }
};

export const getTerminalError = (err: Array<IResponseError>): string => {
  const terminalErrorCode =
    err &&
    Array.isArray(err) &&
    err.find((e: IResponseError) => e.title?.includes(TERMINAL_ERROR_CODES))?.title.replace(TERMINAL_ERROR_CODES, "");
  return (
    (!!terminalErrorCode &&
      i18n.t("common.terminal_error", {
        error: terminalErrorCode,
      })) ||
    ""
  );
};

export const isResponseWithSourceErrorArray = (
  response: any
): response is Array<TRequiredKeys<IResponseError, "source">> => {
  let sourceInEveryError = false;
  if (!response || (response && !Array.isArray(response))) {
    return false;
  }
  response.forEach((error: any) => {
    sourceInEveryError = "source" in error;
  });

  return Array.isArray(response) && sourceInEveryError;
};
